// gameConstants.js

export const gameStartDates = {
    crossword: '2024-07-31',
    mini: '2024-07-31',
    ridella: '2024-07-31',
    clique: '2024-08-05',
    proximity: '2024-08-06',
    sudoku: '2024-07-31',
  };